// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__9XjqE","icon":"SortAdornment_icon__1QfbU","up":"SortAdornment_up__2bs4_","down":"SortAdornment_down__39LqK","active":"SortAdornment_active__2IQbk"};